import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import {
  BannerErrorState,
  BannerFormSkeleton,
  BannerFormTemplate,
  useBanner,
  useBannerTranslations,
} from '@/features/banner-management';
import { PageHeader } from '@/shared/ui/organisms/PageHeader';

export const Route = createFileRoute('/_authenticated/banners/$bannerId/')({
  component: BannerEditPage,
});

/** Página de edição de Banner. */
export function BannerEditPage() {
  const { t } = useTranslation('banner');
  const navigate = useNavigate();
  const { bannerId } = Route.useParams();
  const parsedId = Number(bannerId);

  const { banner, isLoading, isError, refetch } = useBanner(
    Number.isNaN(parsedId) ? undefined : parsedId,
  );
  const {
    langs,
    isLoading: isLoadingLangs,
    isError: isLangsError,
    refetch: refetchLangs,
  } = useBannerTranslations(Number.isNaN(parsedId) ? undefined : parsedId);

  const goToList = () => void navigate({ to: '/banners' });

  return (
    <div className="flex flex-col gap-mini">
      <PageHeader
        title={t('banner.form.editTitle')}
        subtitle={t('banner.form.pageHint')}
        breadcrumb={
          <Breadcrumb>
            <BreadcrumbLink>
              <Link to="/">
                <BreadcrumbIcon />
              </Link>
            </BreadcrumbLink>
            <BreadcrumbLink>
              <Link to="/banners">{t('banner.breadcrumb.banners')}</Link>
            </BreadcrumbLink>
            <BreadcrumbPage>{t('banner.breadcrumb.edit')}</BreadcrumbPage>
          </Breadcrumb>
        }
      />

      {isError || isLangsError ? (
        <BannerErrorState
          message={t(isError ? 'banner.form.toast.loadError' : 'banner.form.toast.langsLoadError')}
          onRetry={() => {
            if (isError) void refetch();
            if (isLangsError) void refetchLangs();
          }}
        />
      ) : isLoading || isLoadingLangs ? (
        <BannerFormSkeleton />
      ) : banner ? (
        <BannerFormTemplate banner={banner} langs={langs} onCancel={goToList} />
      ) : null}
    </div>
  );
}
